import TabOptions from '../options';

export class Model {}
export class Tab {
  id = 'Seven';
  title = 'VII';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    model.areas = model.categories.flatMap(
      (c) =>
        c.areas?.map((a) => {
          if (a.area?.options) delete a.area.options;
          return a;
        }) ?? []
    );
    delete model.categories;
    return {
      tab: this.id,
      ...model,
    };
  };
}
export default new Tab();
